import { stringify } from "querystring";
import ApiService from "./ApiService";
import { ORDERING } from "constants/ApiConstant";
import {
  DEFAULT_ORDERING,
  DEFAULT_ORDERING_LOYALTY_USERS,
  DEFAULT_ORDER_FIELD,
  DEFAULT_ORDER_FIELD_LOYALTY_USERS,
} from "constants/LoyaltyUsersConstants";

const ENDPOINTS = {
  LIST_CONTACTS_FOR_LOYALTY: "loyalty/contacts/available/",
  CREATE_LOYALTY_USER: "user/loyalty/",
  LIST_CONTACTS_IN_LOYALTY_APP: "loyalty/contacts/",
  USER_POINTS_HISTORY: "loyalty-point-history/",
  LOYALTY_USER_VOUCHERS: "loyalty-user-vouchers/",
};

class LoyaltyUsersService extends ApiService {
  getAvailableContacts = async (
    page,
    perPage,
    search,
    order = "",
    orderField = ""
  ) => {
    const queryStringParams = {
      page,
      per_page: perPage,
      search: search,
      ordering: `${order === ORDERING.DESC ? "-" : ""}${orderField},${
        orderField !== DEFAULT_ORDER_FIELD ? DEFAULT_ORDERING : ""
      }`,
    };
    return await this.apiClient.get(
      `${ENDPOINTS.LIST_CONTACTS_FOR_LOYALTY}?${stringify(queryStringParams)}`
    );
  };

  createLoyaltyUser = async (data) => {
    return await this.apiClient.post(ENDPOINTS.CREATE_LOYALTY_USER, data);
  };

  getContactsInLoyaltyApp = async (
    page,
    perPage,
    search,
    order = "",
    orderField = ""
  ) => {
    const queryStringParams = {
      page,
      per_page: perPage,
      search: search,
      ordering: `${order === ORDERING.DESC ? "-" : ""}${orderField},${
        orderField !== DEFAULT_ORDER_FIELD_LOYALTY_USERS
          ? DEFAULT_ORDERING_LOYALTY_USERS
          : ""
      }`,
    };
    return await this.apiClient.get(
      `${ENDPOINTS.LIST_CONTACTS_IN_LOYALTY_APP}?${stringify(
        queryStringParams
      )}`
    );
  };

  getUserPointsHistory = async (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.USER_POINTS_HISTORY}?${stringify(payload)}`
    );
  };

  getLoyaltyUserVouchers = async (payload) => {
    return this.apiClient.get(
      `${ENDPOINTS.LOYALTY_USER_VOUCHERS}?${stringify(payload)}`
    );
  };
}

export default new LoyaltyUsersService();
